var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectionBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1282 1.33301H9.33337V13.333H28V4.33301C28 1.93301 26.0855 1.33301 25.1282 1.33301Z",
    fill: "#3C55A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 14.533V23.333C30.6667 29.1997 29.2 30.6663 23.3334 30.6663H8.66671C2.80004 30.6663 1.33337 29.1997 1.33337 23.333V8.66634C1.33337 2.79967 2.80004 1.33301 8.66671 1.33301H10.8667C13.0667 1.33301 13.5507 1.97834 14.3867 3.09301L16.5867 6.02634C17.144 6.75967 17.4667 7.19967 18.9334 7.19967H23.3334C29.2 7.19967 30.6667 8.66634 30.6667 14.533Z",
    fill: "#5679EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7324 13.5109L22.8863 15.5829C24.3713 16.176 24.3713 17.1567 22.8863 17.7498L17.7324 19.8217C17.1472 20.059 16.1863 20.059 15.601 19.8217L10.4471 17.7498C8.96212 17.1567 8.96212 16.176 10.4471 15.5829L15.601 13.5109C16.1863 13.2737 17.1472 13.2737 17.7324 13.5109Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 20C9.33337 20.6289 9.84671 21.3552 10.4741 21.6097L16.0067 23.8708C16.4304 24.0431 16.9112 24.0431 17.3267 23.8708L22.8593 21.6097C23.4867 21.3552 24 20.6289 24 20",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionBlue);
export default __webpack_public_path__ + "static/media/collection-blue.e2df134b.svg";
export { ForwardRef as ReactComponent };